import React, { useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { useCenter } from "./hooks/useCenter";
import { showToast } from "../../../core/utils/alert";
import { all_routes } from "../../router/all_routes";

const CenterModals: React.FC<{ 
  centerId?: string, 
  showDeleteModal?: boolean, 
  setShowDeleteModal?: (show: boolean) => void;
}> = ({ 
  centerId, 
  showDeleteModal, 
  setShowDeleteModal,
}) => {
  const { deleteCenter } = useCenter();
  const [showAssociateRecordModal, setShowAssociateRecordModal] = useState(false);

  const handleDelete = async () => {
    if (centerId) {
      const result: any = await deleteCenter(centerId);
      if (result.success) {
        showToast({
          title: "Success",
          text: result.message || "Record deleted successfully",
          icon: "success",
        });
        setShowDeleteModal?.(false);
      } else if (result.status === 409) {
        setShowAssociateRecordModal(true);
        setShowDeleteModal?.(false);
      } else {
        showToast({
          title: "Error",
          text: result.error || "Could not delete the record",
          icon: "error",
        });
      }
    }
  };

  return (
    <>
      {/* Delete Modal */}
      {showDeleteModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show" style={{ display: 'block' }} id="delete-modal">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <form onSubmit={(e) => { e.preventDefault(); handleDelete(); }}>
                  <div className="modal-body text-center">
                    <span className="delete-icon">
                      <i className="ti ti-trash" />
                    </span>
                    <h4>Confirm Deletion</h4>
                    <p>
                      You want to delete the record, this can't be undone
                      once you delete.
                    </p>
                    <div className="d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn btn-light me-3"
                        onClick={() => setShowDeleteModal?.(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-danger"
                      >
                        Yes, Delete
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      <>
        {/* Login Details */}
        <div className="modal fade" id="login_detail">
          <div className="modal-dialog modal-dialog-centered  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Login Details</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="student-detail-info">
                  <span className="student-img">
                    <ImageWithBasePath
                      src="assets/img/students/student-01.jpg"
                      alt="Img"
                    />
                  </span>
                  <div className="name-info">
                    <h6>
                      JKaloha <span>Srinagar</span>
                    </h6>
                  </div>
                </div>
                <div className="table-responsive custom-table no-datatable_length">
                  <table className="table datanew">
                    <thead className="thead-light">
                      <tr>
                        <th>User Type</th>
                        <th>User Name</th>
                        <th>Password </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Admin</td>
                        <td>admin53</td>
                        <td>admin@53</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* /Login Details */}
      </>

      {/* Deactivate Modal */}
      {showAssociateRecordModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show" style={{ display: 'block' }} id="deactivate-modal">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div>
                  <div className="modal-body text-center p-4">
                    <div className="warning-icon mb-4">
                      <i className="ti ti-alert-triangle" style={{ fontSize: '4rem', color: '#ffc107' }} />
                    </div>
                    <h4 className="mb-3 fw-semibold">Associated Records Found!</h4>
                    <p className="text-muted mb-4">
                      This center has associated records that prevent deletion. You can either deactivate or delete the associated users of this center.
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                      <button
                        type="button"
                        className="btn btn-light px-4"
                        onClick={() => {
                          setShowAssociateRecordModal(false);
                        }}
                      >
                        Cancel
                      </button>
                      <Link
                        to={all_routes.centerUsersId.replace(":id", centerId || "")}
                        className="btn btn-primary px-4"
                      >
                        Go to Users
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CenterModals;

export { };